import React from 'react';
import ShirtDetail from './shirtDetail';
import ShortsDetail from './shortsDetail';
import OthersDetail from './othersDetail';

const CustomizationItem = (props) => {
  const Detail = () => {
    if (props.productType === 'tshirt') {
      return (
      <ShirtDetail
        productName={props.productName}
        currency={props.currency}
        sizeName={props.sizeName}
        image={props.image}
        properties={props.customization}
        price={props.unitPrice}
        unitDiscount={props.unitDiscount}
        unitNetPrice={props.unitNetPrice}
        unitPrice={props.unitPrice}
      />
      );
    }
    if (props.productType === 'shorts') {
      return (
        <ShortsDetail
          productName={props.productName}
          sizeName={props.sizeName}
          image={props.image}
          properties={props.customization}
          price={props.unitPrice}
          unitDiscount={props.unitDiscount}
          unitNetPrice={props.unitNetPrice}
          unitPrice={props.unitPrice}
        />
      );
    }
    return (
      <OthersDetail
        productName={props.productName}
        sizeName={props.sizeName}
        image={props.image}
        properties={props.customization}
        unitDiscount={props.unitDiscount}
        unitNetPrice={props.unitNetPrice}
        unitPrice={props.unitPrice}
      />
    );
  };

  return (
    <div className="detailedViewCustomisationItem">
      {Detail()}
    </div>
  );
};

export default CustomizationItem;
